export default function (element, data) {
    if (window.innerWidth < 1100 && window.sessionStorage.getItem("mobilefilters.open")) {
        document.body.classList.add('no-scroll');
        element.classList.add("fast");
        element.classList.add("open");
        
        setTimeout(function () {
            element.classList.remove("fast");
        }, 1000);
    }

    window.addEventListener('mobilefilters.open', function () {
        document.body.classList.add('no-scroll');
        element.classList.add("open");
        window.sessionStorage.setItem("mobilefilters.open", "true");
    });

    element.querySelector(".filters-popup-close").addEventListener("click", function () {
        document.body.classList.remove('no-scroll');
        element.classList.remove("open");
        window.sessionStorage.removeItem("mobilefilters.open");
    });
};

// @widgetLoadingMode:lazy-once
// @widgetLoadingChunk:secondary